export default Object.freeze({
  CREATED: "created",
  OPEN: "open",
  PAID: "paid",
  OVERDUE: "overdue",
  VOID: "void",
  UNCOLLECTIBLE: "uncollectible",
});
